jQuery(function () {
    let currentRoute = localStorage.getItem("currentRoute");
    let result = currentRoute.substring(currentRoute.lastIndexOf("/") + 1);
    if (result == "cart") {
        $(".navigationMenu a").attr("tabindex", "-1");
        $(
            ".l-header-menu-option,.l-header-profile-menu li,.l-header-profile-menu li a,.l-header-menu-option a,.l-header-logo,.profile-menu-section-menu-option,.l-dropdown-selected,.l-header-text,.l-header-profile-user,.l-cart-link,.footer-menu-list li a"
        ).attr("tabindex", -1);
    }
    fetch("/cart.json").then((response) => {
        response.json().then((data) => {
            window.cartdata = data;
            syncCartData();
        });
    });

    if ($(".js-cart-add-on").length) {
        $(document).on("click", ".js-cart-add-on", function (e) {
            e.preventDefault();
            $(this).toggleClass("active");
            $(this).next(".cart-add-on-body").slideToggle();
        });
    }
    if ($(".js-cart-summary-featurebox-toggle").length) {
        $(document).on("click keydown", ".js-cart-summary-featurebox-toggle", function (e) {
            if (e.type === "click" || (e.type === "keydown" && e.key === "Enter")) {
                e.preventDefault();
                $(this).toggleClass("active");
                $(this).attr("aria-expanded", function (i, attr) {
                    return attr == "true" ? "false" : "true";
                });
                $(this).next(".js-cart-summary-featuresbox").slideToggle();
            }
        });
    }

    if ($(".js-cart-product-feature-toggle").length) {
        $(".js-cart-product-feature-toggle").on("click", function (e) {
            e.preventDefault();
            $(this).toggleClass("active");
            $(this).parent().next(".cart-product-features").slideToggle();
        });
    }
});

function doAddToCart(sendToCart = false) {
    $.getJSON("/cart/clear", function (e) {
        let items = getCartToAdd();
        items = items.reverse();
        if (items.length > 0) {
            $.ajax({
                url: "/cart/add.js",
                data: {
                    items: items,
                },
                method: "POST",
                dataType: "JSON",
                success: function (data) {
                    if (sendToCart) {
                        window.location = "/cart";
                    }
                },
                error: function (error) {},
            });
        } else {
            window.location = "/cart";
        }
    });
}

function getCartToAdd() {
    let items = Array();
    $.each(mfb_selection.packages, function (ix, em) {
        let extra_fonts_qty = 0;
        $.each(em.addons, function (ixaddon, addon_item) {
            if (addon_item.title.toLowerCase().indexOf(extra_fonts) !== -1) {
                extra_fonts_qty = parseInt(addon_item.variant_title);
            }
        });
        let _uid = Math.round(new Date().getTime() / 1e3);
        _uid = _uid + ix;
        let item = {};
        item.id = em.variant_id;
        item.quantity = 1;
        let properties = {};
        if (em.id.indexOf("kit") !== -1) {
            if (em.id == "business_website_kit") {
                $(
                    "#js-package-left-for-project .package-item-feature-title .package-item-feature-title-inner"
                ).each(function (ix2, em2) {
                    properties[$(em2).find("span").text()] = $(
                        "#package-business-website-kit .package-item-feature"
                    )
                        .eq(ix2)
                        .find(".package-item-value > span")
                        .text()
                        .trim();
                });
            } else if (em.id == "business_digital_campaign_kit") {
                $(
                    "#js-package-left-for-project .package-item-feature-title .package-item-feature-title-inner"
                ).each(function (ix2, em2) {
                    properties[$(em2).find("span").text()] = $(
                        "#package-business-digital-kit .package-item-feature"
                    )
                        .eq(ix2)
                        .find(".package-item-value > span")
                        .text()
                        .trim();
                });
            } else if (em.id == "business_app_kit") {
                $(
                    "#js-package-left-for-project .package-item-feature-title .package-item-feature-title-inner"
                ).each(function (ix2, em2) {
                    properties[$(em2).find("span").text()] = $(
                        "#package-business-app-kit .package-item-feature"
                    )
                        .eq(ix2)
                        .find(".package-item-value > span")
                        .text()
                        .trim();
                });
            } else if (em.id == "enterprise_standard_kit") {
                $(
                    "#js-package-left-for-enterprise .package-item-feature-title .package-item-feature-title-inner"
                ).each(function (ix2, em2) {
                    if (
                        $(
                            "#package-enterprise-standard-kit .package-item-feature"
                        )
                            .eq(ix2)
                            .find(".package-item-value > span")
                            .text()
                            .trim() !== ""
                    ) {
                        properties[$(em2).find("span").text()] = $(
                            "#package-enterprise-standard-kit .package-item-feature"
                        )
                            .eq(ix2)
                            .find(".package-item-value > span")
                            .text()
                            .trim();
                    }
                });
            }
        }
        properties._uid = _uid;
        item.properties = properties;
        items.push(item);
        $.each(em.addons, function (ixaddon, addon_item) {
            if (addon_item.quantity > 0) {
                item = {};
                item.id = addon_item.id;
                item.quantity = addon_item.quantity;
                let properties = {};
                properties._uid = _uid;
                properties["Extra Fonts"] = extra_fonts_qty;
                item.properties = properties;
                items.push(item);
            }
        });
    });
    return items;
}

function syncCartData() {
    let is_enterprise = false;
    if (
        typeof window.cartdata != "undefined" &&
        window.cartdata.item_count !== 0
    ) {
        $.each(window.cartdata.items, function (ix, em) {
            let variant_id = em.id;
            let variant_handle = em.handle.toString().trim();
            let quantity = em.quantity;
            let extra_fonts_qty = 1;
            if (em.handle == "standard") {
                is_enterprise = true;
            }
            if (
                em?.properties &&
                typeof em.properties["Extra Fonts"] !== "undefined"
            ) {
                extra_fonts_qty = parseInt(em.properties["Extra Fonts"]);
                extra_fonts_qty = extra_fonts_qty / 5 + 1;
            }
            if ($(`[data-variantid="${variant_id}"]`).length > 0) {
                $(`[data-variantid="${variant_id}"]`).prop("checked", true);
                $(`[data-variantid="${variant_id}"]`).trigger("change");
            }
            if ($(`[data-product-handle="${variant_handle}"]`).length > 0) {
                if (variant_handle.indexOf("5-fonts") !== -1) {
                    quantity = parseInt(em.variant_title);
                }
                if (variant_handle.indexOf("package-of-seats") !== -1) {
                    quantity = parseInt(em.variant_title);
                }
                if (
                    variant_handle == "5m-monthly-web-page-views-website-kit" &&
                    extra_fonts_qty > 1
                ) {
                    quantity = quantity / extra_fonts_qty;
                }
                if (
                    variant_handle ==
                        "35m-monthly-digital-ad-impressions-digital-campaign-kit" &&
                    extra_fonts_qty > 1
                ) {
                    quantity = quantity / extra_fonts_qty;
                }
                if (
                    variant_handle == "1-mobile-app-title-app-kit" &&
                    extra_fonts_qty > 1
                ) {
                    quantity = quantity / extra_fonts_qty;
                }
                if (
                    variant_handle == "5m-monthly-web-page-views-standard" &&
                    extra_fonts_qty > 1
                ) {
                    quantity = quantity / extra_fonts_qty;
                }
                if (
                    variant_handle ==
                        "35m-monthly-digital-ad-impressions-standard" &&
                    extra_fonts_qty > 1
                ) {
                    quantity = quantity / extra_fonts_qty;
                }
                if (
                    variant_handle == "1-mobile-app-title-standard" &&
                    extra_fonts_qty > 1
                ) {
                    quantity = quantity / extra_fonts_qty;
                }
                if (variant_handle == "company-desktop-standard") {
                    $(`[data-product-handle="${variant_handle}"]`)
                        .find("input")
                        .prop("checked", true);
                }
                if (variant_handle == "support-standard") {
                    $(`[data-product-handle="${variant_handle}"]`)
                        .find("input")
                        .prop("checked", true);
                }
                if (variant_handle == "onboarding-standard") {
                    $(`[data-product-handle="${variant_handle}"]`)
                        .find("input")
                        .prop("checked", true);
                }
            }
        });
    }
}
